import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';

import { ModalTypes } from 'constants/constants';
import UIState from 'store/UIState';

import BodyTag from 'components/BodyTag';
import Button from 'components/Button';
import Logo from 'components/Logo';

// ======================
// STORE
// ====================== 

const actions = {
  fetchData: () => { 
    return dispatch => {
      
    }
  },
  showModal: UIState.actions.showModal,
};

const selectors = state => {
  return { };
};

const withConnect = connect(selectors, actions);

// ======================
// COMPONENT
// ====================== 
class HomeScreen extends React.Component {
  state = { }
  onSignup = () => this.props.showModal(ModalTypes.SIGNUP)

  render() {
    return (
      <div className="content home">
        <BodyTag className="home"/>

        <div className="banner-wrapper">
          <div className="banner">
            <div className="home-glow" />
            <div className="hero-image">
              <img src="/assets/images/ninjacoke_hs.png" />
            </div>
            <div className="copy">
              <h2>Sell Bigger Sponsorships</h2>
              <p>
                Manage in-stream slideshows across all of your Twitch influencers in real-time. 
                Deliver impressive reports and make all your sponsors happy. 
              </p>
              <Button className="signup xl" onClick={this.onSignup}>Signup Now</Button>
            </div>
            
          </div>
          
        </div>
        <div className="home-wrapper">
        <div className="section partners">
            <div className="section-title">Proud Partners</div>
            <div className="logo-list">
              <div className="logo cloud9"><img src="/assets/partners/cloud9_logo.png" /></div>
              <div className="logo evil"><img src="/assets/partners/evil_geniuses_logo.png" /></div>
              <div className="logo playfly"><img src="/assets/partners/playfly_logo.png" /></div>
              <div className="logo soar"><img src="/assets/partners/soar_logo.png" /></div>
            </div>
          </div>
          <div className="blurbs">
            <div className="blurb">
              <div className="blurb-details">
                <h3>Sponsor-Approved Reporting</h3>
                <p>
                  Deliver detailed reports that make sponsors say: “When can we renew?”
                </p>
              </div>
              <div className="blurb-image">
                <img src="/assets/images/feature_channels.jpg" />
                <p>Channels are tracked and verified that your logos are showing </p>
              </div>
            </div>
            <div className="blurb">
              <div className="blurb-details">
                <h3>Real-Time Sponsor Slideshows</h3>
                <p>
                  Instantly update branded overlays and post chat plugs across every streamer you manage—no reminders or missed queues.
              </p>
              </div>
              <div className="blurb-image">
                <img src="/assets/images/feature_editor.jpg" />
                <p>Update, Add, Remove or Reorder in real-time</p>
              </div>
            </div>
            <div className="blurb">
              <div className="blurb-details">
                <h3>Streamlined Streamer Insights</h3>
                <p>
                  View individual streamer performance in a clean, intuitive dashboard designed for speed, clarity, and action.
                </p>
              </div>
              <div className="blurb-image">
                <img src="/assets/images/feature_report.jpg" />
                <p>Generate reports for any date range and campaigns</p>
              </div>
            </div>
          </div>
         
          <div className="section sponsors">
            <div className="section-title">Powering These Brands</div>
            <div className="logo-list">
            <div className="logo soar"><img src="/assets/sponsors/kia_logo.png" /></div>
              <div className="logo alienware"><img src="/assets/sponsors/alienware3.png" /></div>
              <div className="logo asus"><img src="/assets/sponsors/asus.png" /></div>
              <div className="logo gme"><img src="/assets/sponsors/gamestop_logo.png" /></div>
              <div className="logo sofi"><img src="/assets/sponsors/sofi.png" /></div>
              <div className="logo rog"><img src="/assets/sponsors/republic_of_gamers.png" /></div>
              <div className="logo respawn"><img src="/assets/sponsors/respawn_logo.png" /></div>
              <div className="logo expressvpn"><img src="/assets/sponsors/expressvpn.png" /></div>
              <div className="logo gfuel"><img src="/assets/sponsors/gfuel.png" /></div>
              <div className="logo scuff"><img src="/assets/sponsors/scuff_gaming.png" /></div>
              <div className="logo zaxbys"><img src="/assets/sponsors/zeeni_logo.png" /></div>
            </div>
          </div>
          <div className="pitch">
            <Logo showName={false} />
            <h2>HappyStreams isn’t software.</h2>
            <p>It’s your team’s secret weapon to win sponsors for life.</p>
            <Button className="signup" size="l" onClick={this.onSignup}>Signup Now</Button>
          </div>
        </div>
      </div>);
  }
}
export default HomeScreen
  |> withConnect;



